import { createContext } from "react";

export const FeaturedContext = createContext();
